import { EstimateRow } from "features/subscriptions/components/ManageSubscription/EstimateRow";
import type { InvoiceEstimate } from "features/subscriptions/types";
import { formatPrice, parseEstimate } from "features/subscriptions/utils";

export default function CreditsApplied({
  estimate,
  isLoading,
}: {
  estimate: InvoiceEstimate;
  isLoading: boolean;
}) {
  let creditsApplied = 0;

  if (estimate) {
    creditsApplied = parseEstimate(estimate).creditsApplied;
  }

  if (creditsApplied) {
    return (
      <div className="py-1 flex border bg-purple-25 border-purple-50 rounded-xl">
        <EstimateRow
          label="Credits used"
          tooltipText="The amount of promotional credits that will be used for this payment"
          valueComponent={
            <span className="text-purple-600 text-md-bold">{`-${formatPrice(creditsApplied)}`}</span>
          }
          isLoading={isLoading}
        />
      </div>
    );
  }
}
